import React from "react";
import PageWrapper from "../../components/UI/PageWrapper";
import ProfileSectionedArtistProfile from "../../components/Profile/ProfileSectionedArtistProfile";

const ProfileAccountInformationPage: React.FC = () => {
  return (
    <PageWrapper>
      <ProfileSectionedArtistProfile activeSection="account" />
    </PageWrapper>
  );
};

export default ProfileAccountInformationPage;

